const moment = require("moment");

class GenerateurEcheancier {
    constructor(soldeRestant) {
        this.setSoldeRestant(soldeRestant);
        this.calcSoldeRestant();
        this.initListeners();
        $('#fraisResil').trigger('keyup');
    }

    setSoldeRestant(soldeRestant) {
        this.soldeRestant = soldeRestant;
        this.calcSoldeRestant();
    }


    addRowEcheance(montant, date) {
        let tableEcheancier = $('#body-table-echeancier')
        let nextRowIndex = tableEcheancier.data('rowindex') + 1;
        tableEcheancier.data('rowindex', nextRowIndex)

        $('#row-add-echeance').before(
            $('<tr></tr>').append(
                $('<td></td>').append(
                    $('<input/>').prop({
                        name: 'echeances[' + nextRowIndex + '][date]',
                        placeholder: 'Date au format JJ/MM/AAAA',
                        class: 'form-control datePicker input-date-une-echeance position-relative',
                        type: 'text',
                        value: date,
                    }).attr('data-toggle', 'datetimepicker')
                )
            ).append(
                $('<td></td>').append(
                    $('<div></div>').prop({
                        class: 'input-group'
                    }).append(
                        $('<input/>').prop({
                            name: 'echeances[' + nextRowIndex + '][montant]',
                            class: 'form-control input-montant-une-echeance',
                            type: 'number',
                            step: '0.01',
                            value: montant,
                        }).attr('aria-describedby', 'input-montant-par-echeance-'+ nextRowIndex)
                    ).append(
                        $('<div></div>').prop({
                            class: 'input-group-append'
                        }).append(
                            $('<span></span>').prop({
                                class: 'input-group-text',
                                id: 'input-montant-par-echeance-'+ nextRowIndex,
                            }).text('€')
                        )
                    )
                )
            ).append(
                $('<td></td>').append(
                    $('<button></button>').prop({
                        class: 'btn btn-danger btn-delete-echeance',
                        type: 'button',
                        title: 'Supprimer l\'échéance'
                    }).append(
                        $('<span></span>').prop({
                            class: 'far fa-trash'
                        })
                    )
                )
            )
        )

        tableEcheancier.find('.datePicker').datetimepicker({
            locale: 'fr',
            format: 'DD/MM/YYYY',
            icons: {
                time: "far fa-clock-o",
                date: "far fa-calendar",
                up: "far fa-arrow-up",
                down: "far fa-arrow-down",
                next: "far fa-arrow-right",
                previous: "far fa-arrow-left"
            },
        });

        //  lorsqu'on change la date d'une échéance on vérifie qu'il y a bien un mois d'écart entre toutes les échéances sinon une alerte apparaîtra
        $("input.input-date-une-echeance[name='echeances[" + nextRowIndex + "][date]']").on("dp.change", function () {
            const selectedDate = moment(this.value, 'DD/MM/YYYY');
            let alertActive = false,
                dateDiff = null;
            $('.input-date-une-echeance').not(this).map(function () {
                const currDate = moment(this.value, 'DD/MM/YYYY');
                if (selectedDate > currDate) {
                    dateDiff = selectedDate.diff(currDate, 'months')
                } else {
                    dateDiff = currDate.diff(selectedDate, 'months')
                }
                if (dateDiff <= 0) {
                    alertActive = true
                }
            })
            if (alertActive) {
                $('#echeanceEspaceWarning').show();
            } else {
                $('#echeanceEspaceWarning').hide();
            }
        });

    }

    calcSoldeRestant() {
        let btnConfirm = $('#btn-confirm-create-echeancier');
        btnConfirm.prop('disabled', false);

        let futurSoldeRestant = this.soldeRestant;
        let totalEcheancier = 0;
        $('#body-table-echeancier').find('tr td .input-montant-une-echeance').each(function (i, el) {
            let montantEcheance = floatFromInput(el);
            if (!isNaN(montantEcheance)) {
                futurSoldeRestant -= montantEcheance;
                totalEcheancier += montantEcheance;
            }
        });

        $('#input-solde-post-echeancier').val(futurSoldeRestant.toFixed(2));

        $('#alert-futur-solde-neg').remove();
        if (futurSoldeRestant.toFixed(2) < 0) {
            $('#wrapper-alert-echeancier').html(
                $('<div></div>', {
                    id: 'alert-futur-solde-neg',
                    class: 'alert alert-danger',
                    role: 'alert',
                    text: 'Le total des échéance (' + totalEcheancier.toFixed(2) + ' €) ne peut dépasser le total restant dû (' + this.soldeRestant.toFixed(2) + ' €)',
                })
            )
            btnConfirm.prop('disabled', true);
        } else if (futurSoldeRestant.toFixed(2) > 0) {
            $('#wrapper-alert-echeancier').html(
                $('<div></div>', {
                    id: 'alert-futur-solde-neg',
                    class: 'alert alert-warning',
                    role: 'alert',
                    text: 'Le total des échéances (' + totalEcheancier.toFixed(2) + ' €) est inférieur au restant dû (' + this.soldeRestant.toFixed(2) + ' €), il se peut que la personne ne finance pas entièrement sa formation !',
                })
            )
        }
    }

    initListeners() {
        let self = this;
        // Event click génération échéanicer
        $('#btn-generate-echeancier').on('click', function () {
            let nbEcheances = parseInt($('#input-nb-echeance').val());
            let montantEcheance = floatFromInput('#input-montant-echeance');
            let dateEcheance = moment($('#input-date-echeance').val(), "DD/MM/YYYY");

            // On vérifie que la première date d'échéance est une date valide et après "now"
            if (!dateEcheance.isValid() || dateEcheance.isBefore(moment().subtract(1, 'day'))) {
                // Si ce n'est pas le cas on prend la date du jour,
                // à laquel on ajoute un mois et prend le 10
                dateEcheance = moment().add(1, 'months').date(10);
            }

            // On vide les messages d'erreurs
            let errorField = $('#error-field');
            errorField.empty()

            // On check que les champs nombre d'échéances et montant soit bien rempli par un nombre
            if (nbEcheances === undefined || montantEcheance === undefined || isNaN(nbEcheances) || isNaN(montantEcheance)) {
                errorField.html('<div class="alert alert-danger" role="alert">Les champs "Nombre d\'échéances" et "Montant par échéance" sont requis.</div>')
                return;
            }

            // On clean le tableau avant de générer le nouvel échéancier
            $('#body-table-echeancier').children('tr').not('#row-add-echeance').remove();

            // Si la multiplication du nombre d'échéance par le montant est supérieur au dû,
            // On décrémente le nombre d'échéances jusqu'à ce que ce ne soit plus le cas.
            // Cela permet de jouer avec l'affichage user friendly et le calcule dynamique de la dernière échéance
            if ((nbEcheances * montantEcheance) > self.soldeRestant) {
                while ((nbEcheances * montantEcheance) > self.soldeRestant) {
                    nbEcheances--;
                }
            }
            // On calcule le reste après division du solde restant par le montant de l'échéance
            let reste = - Math.round((nbEcheances * montantEcheance - self.soldeRestant + Number.EPSILON) * 100) / 100
            for (let i = nbEcheances - 1; i >= 0; i--) {
                // Si on génère la dernière ligne et que le reste est inférieur à la moitié d'une échéance,
                // on ajoute ce reste à la dernière échéance
                if (i === 0 && reste < (montantEcheance / 2)) {
                    montantEcheance += reste;
                }
                // On ajoute la ligne au tableau
                self.addRowEcheance(montantEcheance.toFixed(2), dateEcheance.format('DD/MM/YYYY'));
                // On incrémente la date d'un mois pour l'échéance suivante
                dateEcheance.add(1, 'months');

                // Si on génère la dernière ligne et que le reste est supérieur à la moitié d'une échéance,
                // on créer une ligne supplémentaire pour le reste seule afin que la dernière échéance ne soit pas trop grosse
                if (i === 0 && reste !== 0 && reste > (montantEcheance / 2)) {
                    self.addRowEcheance(reste.toFixed(2), dateEcheance.format('DD/MM/YYYY'));
                }
            }

            // On recalcule le solde restant après échéancier
            self.calcSoldeRestant();
        });

        // Event change radio bouton mode calcul auto
        $('input.radio-option-generateur').on('change', function () {
            $('#input-montant-echeance, #input-nb-echeance').prop('readonly', false);

            if ($('#radio-calcul-echeances').prop('checked')) {
                $('#input-nb-echeance').prop('readonly', true);
            } else if ($('#radio-calcul-montant').prop('checked')) {
                $('#input-montant-echeance').prop('readonly', true);
            }
        });

        // Event keyup input montant échéance générateur
        // (event debouncé pour limiter spam du keyup)
        $('#input-nb-echeance').on('keyup', debounce(function () {
            let errorField = $('#error-field');
            errorField.empty();
            $('#warning-round').remove();

            let inputNbEcheance = $('#input-nb-echeance');
            // On récupère le nombre d'échéance désiré
            let nbEcheances = parseInt(inputNbEcheance.val());
            // Si un nombre supérieur à 100 est saisie, on le rammène à 100
            // pour éviter une génération trop énervée qui ferai la page
            if (nbEcheances > 100) {
                nbEcheances = 100;
                inputNbEcheance.val(100);
            }

            let inputMontantEchance = $('#input-montant-echeance');
            // On calcule le montant de l'échéance à 2 chiffres significatifs
            let montantEcheance = toFixed(self.soldeRestant / nbEcheances, 2);
            // Si le montant calculé n'est pas un nombre valide, on vide l'input et return false
            if (isNaN(montantEcheance)) {
                inputMontantEchance.val('');
                return false;
            }
            // On affecte à l'input le montant calculé
            inputMontantEchance.val(montantEcheance);
            // Si le montant de l'échéancier total dépasse le solde restant, on affiche un warning
            // expliquant que la dernière échéance sera ajustée
            if ((montantEcheance * nbEcheances) !== self.soldeRestant) {
                errorField.after('<div class="alert alert-warning" id="warning-round">Le montant des échéances est arrondi, la somme manquante sera imputée sur la dernière échéances.</div>')
            }
        }, 250));

        // Event keyup input nombre d'échéance générateur
        // (event debouncé pour limiter spam du keyup)
        $('#input-montant-echeance').on('keyup', debounce(function () {
            let errorField = $('#error-field');
            errorField.empty();
            $('#warning-round').remove();

            // On récupère le montant désiré
            let montantEcheance = floatFromInput(this);
            // Si le montant dépasse le solde, on affiche une erreur et return false
            if (montantEcheance > self.soldeRestant) {
                errorField.html('<div class="alert alert-danger" role="alert">Le montant saisie ne peut dépasser le solde restant !</div>');
                return false;
            }

            let inputNbEcheance = $('#input-nb-echeance');
            // On divise le solde restant par le montant pour obtenir le nombre d'échéance
            // On arrondi le résultat à l'entier le plus proche (inférieur à 0.5 => 0, supérieur à 0.5 => 1)
            // La partie flotante est calculé automatiquement par la fonction de génération du tableau
            let nbEcheances = Math.round(self.soldeRestant / montantEcheance);
            // Si le nombre d'échéance calculé est supérieur à 100 ou n'est pas un nombre,
            // on vide l'input du nb d'échéance et return false
            if (nbEcheances > 100 || isNaN(montantEcheance)) {
                inputNbEcheance.val('');
                return false;
            }
            // On affecte à l'input nb échéance la valeur précedemment calculée
            inputNbEcheance.val(nbEcheances);

            // Si le montant de l'échéancier total dépasse le solde restant, on affiche un warning
            // expliquant que la dernière échéance sera ajustée
            if ((nbEcheances * montantEcheance) > self.soldeRestant) {
                errorField.after('<div class="alert alert-warning" id="warning-round">Le nombre d\'échéances est arrondi, la dernière échéance aura un montant différent de celui défini pour arriver au solde.</div>');
            }
        }, 250));


        // Event click ajout ligne échéance
        $('#btn-add-echeance').on('click', function () {
            self.addRowEcheance(null, null)
        });

        let tableEcheancier = $('#body-table-echeancier')
        // Event click delete ligne échéance
        tableEcheancier.on('click', '.btn-delete-echeance', function () {
            $(this).parent('td').parent('tr').remove();
            self.calcSoldeRestant();
        });

        // Event keyup input montant échéance
        // (event debouncé pour limiter spam du keyup)
        tableEcheancier.on('keyup', '.input-montant-une-echeance', debounce(function () {
            self.calcSoldeRestant();
        }, 250));

        $('#fraisResil').on('keyup change', debounce(function () {
            let fraisResil = floatFromInput(this);
            let montantPaye = floatFromInput('#input-montant-paye');

            $('#input-restant-du').val((fraisResil - montantPaye).toFixed(2));
            if (fraisResil > montantPaye) {
                $('#panel-echeancier').show();
                self.setSoldeRestant(floatFromInput('#input-restant-du'));
            } else {
                $('#panel-echeancier').hide();
            }
        }, 250));

    }
}

let isInitGenerateurEcheancier = false;
let generateur = false;
window.initGenerateurEcheancier = function (soldeRestant) {

    if (!isInitGenerateurEcheancier) {
        generateur = new GenerateurEcheancier(soldeRestant);
    }

    isInitGenerateurEcheancier = true;
}

window.updateGenerateurSoldeEcheancier = function (soldeRestant) {
    if (isInitGenerateurEcheancier && generateur) {
        generateur.setSoldeRestant(soldeRestant);
    }
}

window.setEcheancesUpdateValues = function () {
    let date = moment($('#dateEcheancierModalInput').val(), 'DD-MM-YYYY').format('DD-MM-YYYY');
    let momentDate = moment(date, 'DD-MM-YYYY');
    $('.dateEcheanceInputModal').each(function () {
        $(this).find('.dateUpdate').val(date);
        momentDate = moment(date, 'DD-MM-YYYY');
        // Si il y a plus de jours que dans la date
        if(momentDate.date() > moment(date, 'DD-MM-YYYY').add(1, 'month').daysInMonth()){
            date = moment(date, 'DD-MM-YYYY').add(2, 'month');
            date = moment(`01-{${date.month() + 1}-${date.year()}`, 'DD-M-YYYY').format('DD-MM-YYYY');
        }else{
            date = momentDate.add(1, 'month').format("DD-MM-YYYY");
        }
    })
}

if ($('#modalDateEcheancier').length > 0) {
    setEcheancesUpdateValues()
}

$('#dateEcheancierModalInput').on("change.datetimepicker", function () {
    setEcheancesUpdateValues();
});
